// La lecture d'une note : son en-tête YAML devient une liste de propriétés (comme dans Obsidian), et son
// texte est rendu en Markdown, les [[wikiliens]] devenant des liens vers les notes visées.
// Logique pure, testée sans navigateur (test/note.test.js).

/** Le texte sans son en-tête YAML : l'en-tête est montré à part, en propriétés. */
export function corpsSansFrontmatter(contenu: string): string {
  return contenu.replace(/^---\r?\n[\s\S]*?\r?\n---[ \t]*(\r?\n|$)/, '');
}

function texteDe(v: unknown): string {
  if (v === null || v === undefined) return '';
  if (Array.isArray(v)) return v.map(texteDe).join(', ');
  if (typeof v === 'object') return JSON.stringify(v);
  return String(v);
}

/**
 * Les propriétés à afficher. L'`id` (posé par le miroir) et le `titre` (déjà en tête de page) n'apprennent
 * rien au lecteur ; une valeur vide non plus.
 */
export function proprietes(fm: Record<string, unknown>): [string, string][] {
  return Object.entries(fm)
    .filter(([cle]) => cle !== 'id' && cle !== 'titre')
    .map(([cle, v]): [string, string] => [cle.replaceAll('_', ' '), texteDe(v)])
    .filter(([, v]) => v !== '');
}

/**
 * `[[cible]]`, `[[cible|libellé]]`, `[[cible#section]]` → un lien Markdown vers la note quand elle est
 * connue et visible, sinon le libellé en italique (une note pas encore écrite, comme dans Obsidian).
 * Les crochets ou parenthèses du libellé sont neutralisés : ils fermeraient le lien Markdown.
 */
export function avecWikiliens(corps: string, liens: { cible: string; id: string | null }[]): string {
  const ids = new Map(liens.map((l) => [l.cible, l.id]));
  return corps.replace(/\[\[([^\]|#]+)(?:#[^\]|]*)?(?:\|([^\]]+))?\]\]/g, (_tout, cible: string, libelle?: string) => {
    const texte = (libelle ?? cible).trim().replace(/[[\]()]/g, '');
    const id = ids.get(cible.trim());
    return id ? `[${texte}](#/cerveau/${id})` : `*${texte}*`;
  });
}
